import MaterialUiTable from './MaterialUiTable.js'

export default MaterialUiTable
